import React from 'react';

const Mensagem = props => {
    if (!props.mensagem) {
        return null;
    }

    if (props.mensagem.tipo === 'LIMPAR') {
        return null;
    }
    
    if (props.mensagem.tipo === 'sucesso') {
        return (
            <div className="text-primary text-center mt-2 mb-2 ">
                { props.mensagem.texto }
            </div>
        );
    }

    return (
        <div className="text-danger text-center mt-2 mb-2 ">
            { props.mensagem.texto }
        </div>
    );
}

export default Mensagem